import { memo, useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
// @mui
import {
  Box,
  Divider,
  Drawer,
  CardContent,
  Card,
  CardHeader,
  Stack,
  Typography,
  ButtonBase,
  Avatar,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  SvgChevronLeftFill,
  SvgCloseFill,
  SvgDislikeFill,
  SvgLikeFill,
} from '../../SvgIcons';
import { queryUserNotificationDetails, toggleNotificationDetailsDrawer } from '../../../store/actions/slices/notificationActions';
import { getAssetsUrl, getImageUrl } from '../../../utils/@helper/file.helper';
import { onFeedbackHelp } from '../../../store/actions/feebackActions';
import { COMMENT_FLAG, HLEP_FLAG } from '../../../store/types';

// components

// store

/* ======================================================================================= */


/* ======================================================================================= */

const NotificationDetails = ({ ct }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { notification } = useSelector(state => state?.slices);
  const { details } = notification || {};

  const { state, commit } = useContext(ct);


  const handleCloseDetails = (visible) => (event) => {
    dispatch(toggleNotificationDetailsDrawer(visible))
    // commit({
    //   type: 'OPEN_DETAILS_DRAWER',
    //   data: {
    //     ...state,
    //     visible: false,
    //     record: {},
    //     readFlag: null
    //   }
    // });
  };

  return (
    <Drawer
      variant={'temporary'}
      anchor={'right'}
      open={Boolean(notification?.isOpenNotificationDetails)}
    >
      {/* 516 532 */}
      <Card sx={{ width: 532, overflow: 'visible' }}>
        <CardHeader
          disableTypography
          atrr-title={'消息詳情'}
          title={
            <Stack direction={'row'} alignItems={'center'}>
              <Stack direction={'row'} alignItems={'center'} spacing={0.5} paddingBlock={0.5} paddingInlineStart={1} paddingInlineEnd={1.5} sx={{ cursor: 'pointer' }} onClick={handleCloseDetails(false)}>
                <SvgChevronLeftFill color={theme.palette.color.primaryBlue3} size={16} sx={{ padding: '2px' }} />
                <Typography variant='body2' color={theme.palette.color.primaryBlue3}>
                  返回
                </Typography>
              </Stack>
              <Divider sx={{ width: '1px', height: 24, alignSelf: 'center', mx: 1 }} color={'text.secondary'} orientation="vertical" variant="middle" flexItem />
              <Typography variant={'h6'}>{t('ese.notification.details')}</Typography>
            </Stack>
          }
          action={<Box onClick={handleCloseDetails(false)} sx={{ cursor: 'pointer' }}><SvgCloseFill color={'text.primary'} /></Box>}
          sx={{
            py: 1,
            pl: 3,
            pr: 2,
            alignItems: 'center',
            borderBottom: '1px solid #CCC',
            '& .MuiCardHeader-action': {
              m: 0,
              lineHeight: 0,
              alignSelf: 'center',
            }
          }}
        />
        {/* sx={{ borderBottom: `1px solid ${theme.palette.divider}` }} */}
        <CardContent>
          <Stack spacing={2}>
            <Typography variant={'h6'} mb={1} sx={{ ...theme.typography.leftLine, pb: 0.75, wordBreak: 'break-word' }}>
              { details?.titile || details?.messageTitle || '--' }
            </Typography>
            <Typography variant={'body2'} color={'text.secondary'} display={'flex'} alignItems={'center'}>
              {details?.sendTime || details?.createTime}
            </Typography>
            <Box dangerouslySetInnerHTML={{ __html: details?.msgContent || details?.messageContent }}  sx={{ wordBreak: 'break-word' }}/>
            {/* <Typography variant={'body1'} display={'flex'} alignItems={'center'}>
            </Typography> */}
          </Stack>
        </CardContent>

        {
          [COMMENT_FLAG.Replied].includes(Number(details?.messageStatus)) && (
            <CardContent sx={{ borderTop: `1px solid ${theme.palette.divider}` }}>
              <Stack spacing={2}>

                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                  <Stack direction={'row'} spacing={1} alignItems={'center'}>
                    <Avatar sx={{ width: 32, height: 32 }} src={(getAssetsUrl('images/avatars/avatar_1.jpg'))} />
                    <Typography variant='body2' fontWeight={700}>客服(16996) 回覆</Typography>
                  </Stack>
                  <Typography variant='body2'>{details?.processTime}</Typography>
                </Stack>

                <Typography variant='body1' sx={{ wordBreak: 'break-word' }}>
                  {details?.processContent}
                </Typography>

                <Stack direction={'row'} justifyContent={'flex-end'} spacing={1}>
                  <ButtonBase
                    sx={{
                      fontWeight: 700,
                      padding: theme.spacing(0.5, 1),
                      color: 'color.primaryMain',
                      transition: 'all .4s ease',
                      '&:hover': {
                        backgroundColor: 'color.primaryBlue310',
                      }
                    }}
                    onClick={async () => {
                      await dispatch(onFeedbackHelp({ haveOrNo: HLEP_FLAG.True, id: details?.id }));
                      await dispatch(queryUserNotificationDetails(details));
                    }}
                  >
                    有幫助
                    <SvgLikeFill variant={[HLEP_FLAG.True].includes(details?.haveHelp) ? 'contained' : 'outlined'} />
                  </ButtonBase>
                  <ButtonBase
                    sx={{
                      fontWeight: 700,
                      padding: theme.spacing(0.5, 1),
                      color: 'color.primaryMain',
                      transition: 'all .4s ease',
                      '&:hover': {
                        backgroundColor: 'color.primaryBlue310',
                      }
                    }}
                    onClick={async () => {
                      await dispatch(onFeedbackHelp({ haveOrNo: HLEP_FLAG.Fasle, id: details?.id }));
                      await dispatch(queryUserNotificationDetails(details));
                    }}
                  >
                    沒有幫助
                    <SvgDislikeFill variant={[HLEP_FLAG.Fasle].includes(details?.haveHelp) ? 'contained' : 'outlined'} />
                  </ButtonBase>
                </Stack>

              </Stack>
            </CardContent>
          )
        }

        {/* <CardContent>
          <Stack spacing={2}>

            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
              <Stack direction={'row'} spacing={1} alignItems={'center'}>
                <Avatar sx={{ width: 32, height: 32 }} src={(getAssetsUrl('images/avatars/avatar_1.jpg'))} />
                <Typography variant='body2' fontWeight={700}>客服(16996) 回覆</Typography>
              </Stack>
              <Typography variant='body2'>2023/02/23 13:34:56</Typography>
            </Stack>

            <Typography variant='body1'>
              回覆內容回覆內容回覆內容回覆內容回覆內容回覆內容回覆內容回覆內容回覆內容回覆內容。
            </Typography>

            <Stack direction={'row'} justifyContent={'flex-end'} spacing={1}>
              <ButtonBase
                sx={{
                  fontWeight: 700,
                  padding: theme.spacing(0.5, 1),
                  color: 'color.primaryMain',
                  transition: 'all .4s ease',
                  '&:hover': {
                    backgroundColor: 'color.primaryBlue310',
                  }
                }}
                onClick={() => dispatch(onFeedbackHelp({ haveOrNo: HLEP_FLAG.True, id: details?.id }))}
              >
                有幫助
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M10.5941 3H11.1795C12.0627 3 12.9097 3.35084 13.5342 3.97535C14.1587 4.59986 14.5096 5.44688 14.5096 6.33007V8.67011H18.4571C18.8204 8.66681 19.1802 8.74213 19.5118 8.89094C19.8451 9.04052 20.1419 9.26078 20.3816 9.53645C20.6213 9.81212 20.7982 10.1366 20.9001 10.4874C21.0019 10.8383 21.0263 11.207 20.9715 11.5682L19.8545 18.8582C19.7633 19.4589 19.458 20.007 18.9951 20.4005C18.5334 20.7929 17.9459 21.0058 17.3401 21.0003L5.79252 21.0003C5.11684 21.0099 4.46085 20.7721 3.94815 20.3316C3.43331 19.8892 3.09878 19.2733 3.00807 18.6006L3 18.5407V12.7549L3.00678 12.6999C3.09042 12.0222 3.41469 11.397 3.92054 10.9383C4.42639 10.4795 5.08017 10.2177 5.76284 10.2004L5.7742 10.2001H7.40059L10.5941 3ZM8.84564 11.3812V19.2003H17.3548C17.5285 19.2023 17.697 19.1415 17.8293 19.029C17.9616 18.9165 18.0488 18.76 18.0749 18.5884L19.1918 11.2981C19.2073 11.1951 19.2004 11.0893 19.1714 10.9893C19.1423 10.8891 19.0918 10.7964 19.0233 10.7176C18.9548 10.6388 18.87 10.5759 18.7748 10.5332C18.6795 10.4904 18.5762 10.4689 18.4718 10.4701L18.4616 10.4702L12.7095 10.4701V6.33007C12.7095 5.92428 12.5483 5.53511 12.2614 5.24818C12.1066 5.09334 11.922 4.97511 11.721 4.89907L9.43719 10.0493L8.84564 11.3812ZM5.12979 12.2716C5.31371 12.1048 5.55073 12.0087 5.79868 12.0002H7.0456V19.2003H5.77785L5.77013 19.2004C5.53244 19.2045 5.30152 19.1212 5.12121 18.9663C4.95373 18.8224 4.84073 18.626 4.80004 18.41V12.8741C4.83919 12.6424 4.95509 12.4301 5.12979 12.2716Z" fill="#204ACE"/>
                </svg>
              </ButtonBase>
              <ButtonBase
                sx={{
                  fontWeight: 700,
                  padding: theme.spacing(0.5, 1),
                  color: 'color.primaryMain',
                  transition: 'all .4s ease',
                  '&:hover': {
                    backgroundColor: 'color.primaryBlue310',
                  }
                }}
                onClick={() => dispatch(onFeedbackHelp({ haveOrNo: HLEP_FLAG.Fasle, id: details?.id }))}
              >
                沒有幫助
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M10.5941 21.0006H11.1795C12.0627 21.0006 12.9097 20.6498 13.5342 20.0253C14.1587 19.4008 14.5096 18.5537 14.5096 17.6706V15.3305H18.4571C18.8204 15.3338 19.1802 15.2585 19.5118 15.1097C19.8451 14.9601 20.1419 14.7398 20.3816 14.4642C20.6213 14.1885 20.7982 13.864 20.9001 13.5132C21.0019 13.1624 21.0263 12.7936 20.9715 12.4324L19.8545 5.14238C19.7633 4.54168 19.458 3.9936 18.9951 3.6001C18.5334 3.20768 17.9459 2.99478 17.3401 3.00028L5.79252 3.00028C5.11684 2.99075 4.46085 3.22854 3.94815 3.66905C3.43331 4.11139 3.09878 4.72736 3.00807 5.40005L3 5.45992V11.2458L3.00678 11.3007C3.09042 11.9784 3.41469 12.6036 3.92054 13.0624C4.42639 13.5211 5.08017 13.783 5.76284 13.8002L5.7742 13.8005H7.40059L10.5941 21.0006ZM8.84564 12.6194V4.80032H17.3548C17.5285 4.79835 17.697 4.85915 17.8293 4.97162C17.9616 5.08409 18.0488 5.24058 18.0749 5.41227L19.1918 12.7025C19.2073 12.8055 19.2004 12.9113 19.1714 13.0113C19.1423 13.1116 19.0918 13.2043 19.0233 13.283C18.9548 13.3618 18.87 13.4247 18.7748 13.4675C18.6795 13.5102 18.5762 13.5317 18.4718 13.5305L18.4616 13.5304L12.7095 13.5305V17.6706C12.7095 18.0763 12.5483 18.4655 12.2614 18.7524C12.1066 18.9073 11.922 19.0255 11.721 19.1016L9.43719 13.9513L8.84564 12.6194ZM5.12979 11.729C5.31371 11.8958 5.55073 11.9919 5.79868 12.0004H7.0456V4.80032H5.77785L5.77013 4.80018C5.53244 4.79611 5.30152 4.87944 5.12121 5.03436C4.95373 5.17826 4.84073 5.37461 4.80004 5.59062V11.1266C4.83919 11.3582 4.95509 11.5706 5.12979 11.729Z" fill="#204ACE"/>
                </svg>
              </ButtonBase>
            </Stack>

          </Stack>
        </CardContent> */}
      </Card>
    </Drawer>
  );
};

export default memo(NotificationDetails);
